import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { STEP_SELECT_FNOL_TEMPLATE } from '../../CONSTANTS';
import { useFnol } from '../../context';
import { FnolCategoryList } from './components';

const SelectFnolCategoryView = () => {
  const {
    fnolCategories,
    selectedFnolCategory,
    setSelectedFnolCategory,
    setStep,
  } = useFnol();

  const { t } = useTranslation();

  useEffect(() => {
    window.parent.postMessage(
      {
        type: 'navigate',
      },
      '*'
    );
  }, []);

  useEffect(() => {
    if (fnolCategories.length === 1) {
      setSelectedFnolCategory(fnolCategories[0].key);
      setStep(STEP_SELECT_FNOL_TEMPLATE);
    }
  }, [fnolCategories]);

  useEffect(() => {
    if (selectedFnolCategory) setStep(STEP_SELECT_FNOL_TEMPLATE);
  }, [selectedFnolCategory]);

  const handleSelectClick = fnolCategoryKey =>
    setSelectedFnolCategory(fnolCategoryKey);

  return (
    <>
      <h3>{t('selectFnolCategory.header')}</h3>
      <FnolCategoryList onClick={handleSelectClick} />
    </>
  );
};

export default SelectFnolCategoryView;
